
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators, FormGroup, ValidatorFn } from '@angular/forms';
import { AssignTemplateDialogModel } from "../models";

@Component({
  selector: 'app-assign-template-dialog',
  templateUrl: './assign-template-dialog.component.html',
  styleUrls: ['./assign-template-dialog.component.css']
})
export class AssignTemplateDialogComponent implements OnInit {
  form: FormGroup;
  dialogInput: AssignTemplateDialogModel;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AssignTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: AssignTemplateDialogModel) {
    
    this.dialogInput = data;
    this.form = fb.group({
      chosenId: [ '0', [ Validators.required ] ],
      startDate: [ this.dialogInput.startDate ],
      endDate: [ this.dialogInput.endDate ]
//      chosenId: [ this.dialogInput.chosenId.toString(), [ Validators.required ] ]
        //, 
    //    duration: [this.dialogInput.duration, [ Validators.required, Validators.min(1) ]],
      //  numBookings: [this.dialogInput.numBookings]
    });
}

  ngOnInit() {
  }

  get chosenId() { return this.form.get('chosenId'); }

  
  save() {
    this.dialogRef.close(this.form.value);
  }


  close() {
    this.dialogRef.close();
  }

}


/*


    constructor(
        private dialogRef: MatDialogRef<SlotDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: timeSlotDialogModel) {
        
        this.dialogInput = data;
        this.form = fb.group({
            chosenId: [ this.dialogInput.chosenId.toString(), [ Validators.required ] ], 
            duration: [this.dialogInput.duration, [ Validators.required, Validators.min(1) ]],
            numBookings: [this.dialogInput.numBookings]
        });
    }

    ngOnInit() {
    }

    get chosenId() { return this.form.get('chosenId'); }

    get duration() { return this.form.get('duration'); }

    dialogTitle(): string {
      if (this.dialogInput.chosenId == 0)
        return `New Time Slot - ${this.dialogInput.startTime}`;
      else
        return `Edit Time Slot - ${this.dialogInput.startTime}`;
    }

    save() {
        this.dialogRef.close(this.form.value);
    }

}
*/
